import React from 'react';

const MIImage = ({configurable}) => {
    return (
        <div className={"MIImage"}>
            <div>
                <img
                    src={`${process.env.REACT_APP_API_URL + "/" + configurable.image}`}
                    className={'img-fluid'}/>
            </div>
        </div>
    );
};

export default MIImage;